/**
 * Brand registry — per-brand configuration (string fields only).
 *
 * The `logo` asset is intentionally NOT held here: importing every brand's
 * logo eagerly would emit all of them into every build (white-label leak).
 * Instead the active brand's logo is resolved at build time via the
 * `@brand-asset` alias and injected by `getActiveBrand()` in `brand.ts`.
 */
import { BRAND_META } from './brand.meta'
import type { IBrandConfig, BrandKey, IBrandThemeColors } from './brand.types'

/** Per-brand config minus the build-resolved logo asset. */
export type IBrandConfigData = Omit<IBrandConfig, 'logo'>

// DUNE reuses Peraso's theme colours for the initial release.
const SHARED_COLORS: IBrandThemeColors = { primary: '#0077BE' }

export const BRANDS: Record<BrandKey, IBrandConfigData> = {
  peraso: {
    key: 'peraso',
    productName: 'Peraso Customer Portal',
    brandName: 'Peraso',
    // Runtime document title (router/guards.ts) — distinct from the static tab
    // title in brand.meta. Preserves today's value for the Peraso build.
    documentTitle: 'Peraso Customer Portal',
    favicon: BRAND_META.peraso.favicon,
    theme: { colors: { ...SHARED_COLORS } },
    supportEmail: 'support@perasotech.com',
  },
  dune: {
    key: 'dune',
    productName: 'DUNE Wireless Support Portal',
    brandName: 'DUNE Wireless',
    documentTitle: 'DUNE Wireless',
    favicon: BRAND_META.dune.favicon,
    theme: { colors: { ...SHARED_COLORS } },
    supportEmail: 'support@dunewireless.com',
  },
}
